export default __webpack_public_path__ + "static/media/Transfer line 3.aa27face.mp3";